// Файл: src/utils/roles.js
// Те же правила, что на сервере (backend/utils/roles.js). Сервер проверяет
// сам; здесь — чтобы не показывать кнопки и разделы, которые всё равно откажут.
//
//  rep            — медпред
//  manager        — региональный менеджер: свои медпреды (смотреть, планировать)
//  brand_manager  — бренд-менеджер: все медпреды и продажи, только просмотр
//  admin          — администратор

const roleOf = (user) => String(user?.role || '').toLowerCase();

export const ROLES = ['rep', 'manager', 'brand_manager', 'admin'];
export const isAdmin = (user) => roleOf(user) === 'admin';
// Видит других сотрудников: выбор медпреда в отчётах, календаре, карта
export const canViewTeam = (user) => ['admin', 'manager', 'brand_manager'].includes(roleOf(user));
// Ставит планы и меняет события другим
export const canPlanForTeam = (user) => ['admin', 'manager'].includes(roleOf(user));
// Добавляет и правит врачей и аптеки (удаляет — только админ)
export const canEditDirectory = (user) => ['rep', 'manager', 'admin'].includes(roleOf(user));
// Аналитика продаж и склад
export const canViewSales = (user) => ['admin', 'brand_manager'].includes(roleOf(user));
